"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonStyled = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactstrap = require("reactstrap");
var _excluded = ["onClick", "faIcon", "showButton", "children"];
var ButtonStyled = exports.ButtonStyled = function ButtonStyled(_ref) {
  var onClick = _ref.onClick,
    faIcon = _ref.faIcon,
    showButton = _ref.showButton,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!showButton) return null;
  var ButtonIcon = function ButtonIcon() {
    if (!faIcon) return null;
    return _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: faIcon
    });
  };
  return _react["default"].createElement(_reactstrap.Button, (0, _extends2["default"])({
    className: "m-1"
  }, rest, {
    onClick: onClick
  }), _react["default"].createElement(ButtonIcon, null), _react["default"].createElement("span", {
    className: !!faIcon ? "ps-1" : ''
  }, children));
};
ButtonStyled.propTypes = {
  onClick: _propTypes["default"].func,
  faIcon: _propTypes["default"].node,
  showButton: _propTypes["default"].bool,
  children: _propTypes["default"].string
};
ButtonStyled.defaultProps = {
  showButton: true
};